import { AppPlanInfo, getPlanName, PlanPrivacy, SubscriptionType } from "common/app-plans";
import { CardPreview } from "common/firebase-function-types";
import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";
import { GlideFC } from "lib/glide-fc";
import AppPlanBillingInfo from "./app-plan-billing-info";
import { AppPlanConfirmContainer } from "./app-plan-confirm-styles";

interface Props {
    fromPanel: boolean;
    appPlanInfo: AppPlanInfo;
    appName: string;
    privacy: PlanPrivacy;
    subscription: SubscriptionType;
    cardPreview: CardPreview;
    editBilling: () => void;
}

const AppPlanConfirm: GlideFC<Props> = p => {
    const { appPlanInfo, subscription, appName, privacy, editBilling, cardPreview, fromPanel } = p;
    const planName = getPlanName(appPlanInfo.code).short;

    const isPrivate = privacy === PlanPrivacy.Private;
    const isAnnual = subscription === SubscriptionType.Annual;
    const interval = subscription === SubscriptionType.Annual ? "1 year " : "";
    const includeMsg = isPrivate ? " including:" : "";
    const planAppNameMsg = `${interval}${planName} upgrade for "${appName}"${includeMsg}`;
    const billingIntervalMsg = `You will be charged every ${
        subscription === SubscriptionType.Annual ? "year" : "month"
    } until you cancel`;

    const usersMsg = `${appPlanInfo.numberOfUsers} private users`;
    const usersBillingWarning = `If you go over ${appPlanInfo.numberOfUsers} users in a month, you'll be charged $2 per additional user at the end
    of that month.`;

    return (
        <AppPlanConfirmContainer>
            <div className="group pad-bottom-large">
                <div className="horiz">
                    <div className="bold med">Please review and confirm the information below</div>
                </div>
                <div className="section">
                    <div className="bold med margin-bottom">{planAppNameMsg}</div>
                    {isPrivate && (
                        <>
                            <div className="horiz no-stretch margin-bottom">
                                <div className="sm pad-right">{usersMsg}</div>
                                {!fromPanel && isAnnual && (
                                    <ButtonVNext
                                        buttonType="minimal"
                                        variant="accent"
                                        label="Change"
                                        size="xsm"
                                        onClick={editBilling}
                                    />
                                )}
                            </div>
                            <div className="xxsm margin-bottom pale">{usersBillingWarning}</div>
                        </>
                    )}
                    <div className="xxsm pale">{billingIntervalMsg}</div>
                </div>
            </div>
            <AppPlanBillingInfo cardPreview={cardPreview} editBilling={editBilling} />
        </AppPlanConfirmContainer>
    );
};

export default AppPlanConfirm;
